module.exports = __webpack_public_path__ + "img/kxb_log.98eef66b.png";